export const USER_DETAILS = "/api/user/me";
export const CREATE_TAG = "/api/tag/create";
export const TAG_LIST = "/api/tag/list";
export const XR_ASSET_VERSION_CREATE = "/api/resource/asset/create/version";
export const CREATE_RESOURCE = "/api/resource/unverified/module/create";
export const UNVERIFIED_RESOURCE = "/api/resource/unverified/list";
export const PLAY_RESOURCE_DETAILS = "/api/resource/unverified/play/details";
export const XR_MODULE_DETAIL = "/api/resource/unverified/module/basic";
export const ASSET_SAVE_DETAIL = "/api/resource/unverified/3d/asset/basic";
export const ASSET_CREATE_VERSION = "/api/resource/3d/asset/create/version";
export const ASSET_BASIC_DETAIL = "/api/resource/3d/asset/details";
export const GET_VERSION_HISTORY = "/api/resource/asset/all/type/versions";
export const SAVE_ASSESSMENT = "/api/resource/unverified/assessment";
export const RESOURCE_QUIZ = "/api/resource/module/quiz";
